/**
 * Select the best animation image URL based on priority
 * Priority: explicit SVG > explicit image URL > person portrait
 * @param {string} imageUrlSvg - Explicit SVG image URL
 * @param {string} imageUrl - Explicit image URL
 * @param {string} portraitUrl - Person's portrait URL
 * @returns {string} The selected image URL
 */
export function selectAnimationImage(imageUrlSvg, imageUrl, portraitUrl) {
  return imageUrlSvg || imageUrl || portraitUrl
}

/**
 * Determine if a click event should trigger card animation
 * Returns false if: non-primary click, modified click, or external link
 * @param {Event} event - The click event
 * @param {string} splash - The splash type ('external', 'internal', etc)
 * @returns {boolean} True if click should animate; false otherwise
 */
export function isValidClickForAnimation(event, splash) {
  // Don't intercept non-primary clicks or modified clicks
  if (event.button !== 0 || event.metaKey || event.ctrlKey) {
    return false
  }

  // Don't animate external links — they open in a new tab/window; the browser handles navigation
  if (splash === 'external') {
    return false
  }

  return true
}
